// extracted by mini-css-extract-plugin
export var infoRow = "_uz-2";
export var labelContainer = "_uz-0";
export var rightInfo = "_uz-1";